<ion-header class="ion-no-border page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios">
      <div  (click)="goHome()" class="header-logo">&nbsp;</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="showMenu()" class="menu" [attr.aria-label]="'ARIA.MENU.BUTTON.LABEL_0' | translate">
        <ion-icon slot="icon-only" aria-hidden="true"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="page-title" translate>SETTINGS.TITLE</div>

</ion-header>

<ion-content class="ion-padding page2" no-bounce>

  <ng-template [ngIf]="isLoading">
    <div class="v-box full-width full-height justify-around align-center">
      <ion-spinner color="dark"></ion-spinner>
    </div>
  </ng-template>

  <ng-template [ngIf]="!isLoading">

    <h2 translate>SETTINGS.MODE.TITLE</h2>

    <ion-segment scrollable [(ngModel)]="mode" (ionChange)="modeChanged()">
      <ion-segment-button value="simple">
        <div translate>MODE.SIMPLE.LABEL</div>
       </ion-segment-button>
       <ion-segment-button value="standard">
        <div translate>MODE.STANDARD.LABEL</div>
       </ion-segment-button>
    </ion-segment>

    <div class="spacer"></div>

    <h2 translate>SETTINGS.LANGUAGE.TITLE</h2>

    <ion-segment scrollable [(ngModel)]="lang" (ionChange)="langChanged()">
      <ion-segment-button value="de">
        <div translate>SETTINGS.LANGUAGE.GERMAN</div>
       </ion-segment-button>
       <ion-segment-button value="en">
        <div translate>SETTINGS.LANGUAGE.ENGLISH</div>
       </ion-segment-button>
    </ion-segment>

    <div class="spacer"></div>

    <h2 translate style="position:relative">SETTINGS.DIALOGS.NAME
      <span item-end class="help-icon help-icon-free">
        <ion-icon slot="end" name="help-circle-outline" (click)="showHelp('SETTINGS.DIALOGS.HELP')" [attr.aria-label]="'SETTINGS.DIALOGS.HELP_ICON' | translate"></ion-icon>
      </span>
    </h2>
    <ion-item>
      <ion-label translate>SETTINGS.DIALOGS.FIRST</ion-label>
      <ion-datetime-button *ngIf="!dialogsTimesAutomatic" datetime="datetimeTimesDialogsFirst"></ion-datetime-button>
      <span item-end translate *ngIf="!dialogsTimesAutomatic">SETTINGS.TIMES.CLOCK</span>
      <span item-end translate *ngIf="dialogsTimesAutomatic"(click)="setDialogsTimesAutomatic(false)">SETTINGS.TIMES.AUTOMATIC.TEXT</span>
    </ion-item>
    <ion-item>
      <ion-label translate>SETTINGS.DIALOGS.SECOND</ion-label>
      <ion-datetime-button *ngIf="!dialogsTimesAutomatic" datetime="datetimeTimesDialogsSecond"></ion-datetime-button>
      <span item-end translate *ngIf="!dialogsTimesAutomatic">SETTINGS.TIMES.CLOCK</span>
      <span item-end translate *ngIf="dialogsTimesAutomatic" (click)="setDialogsTimesAutomatic(false)">SETTINGS.TIMES.AUTOMATIC.TEXT</span>
    </ion-item>

    <div *ngIf="displayShowLeaderOnly" class="spacer"></div>

    <h2 *ngIf="displayShowLeaderOnly" translate>SETTINGS.LEADERONLYCONTENT.NAME</h2>

    <ion-item *ngIf="displayShowLeaderOnly">
      <ion-badge class="badge-leader"><ion-icon name="people" class="icon"></ion-icon></ion-badge>
      <ion-label color="dark" translate>
        SETTINGS.LEADERONLYCONTENT.LABEL
      </ion-label>
      <ion-toggle slot="end" [(ngModel)]="settings.showLeaderContent"></ion-toggle>
    </ion-item>

@if(mode != 'simple'){
    <div class="spacer"></div>

    <h2 translate>SETTINGS.THEME.NAME</h2>

    <ng-template ngFor let-curTheme [ngForOf]="allThemes">
      <ion-segment [(ngModel)]="theme" (ionChange)="themeChanged()">
        <ion-segment-button value="{{curTheme+' '+sub}}" class="theme {{curTheme}} {{sub}}" *ngFor="let sub of ['light', 'full', 'dark']">
          <div>{{'SETTINGS.THEME.' + curTheme.toUpperCase() | translate}} {{'SETTINGS.THEME.SUB.' + sub.toUpperCase() | translate}}</div>
        </ion-segment-button>
      </ion-segment>
    </ng-template>
}

    <div class="spacer"></div>

    <ion-list lines="none" class="sett-menu">
      <ion-item button (click)="showPositionPage()" *ngIf="showMenuEntry('MENU.PROFILE.MYPROFILE')"><div translate>MENU.PROFILE.MYPROFILE</div></ion-item>
      <ion-item button (click)="toggleMenu('account')" *ngIf="showMenuEntry('MENU.PROFILE.MYACCOUNT')"><div translate>MENU.PROFILE.MYACCOUNT</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('account') && showMenuEntry('MENU.PROFILE.CHANGE_PASSWORD')" (click)="showPasswordSetPage()"><div translate>MENU.PROFILE.CHANGE_PASSWORD</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('account') && showMenuEntry('MENU.PROFILE.LOGOUT')" (click)="logout()"><div translate>MENU.PROFILE.LOGOUT</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('account') && showMenuEntry('MENU.PROFILE.UNREGISTER')" (click)="unregister()"><div translate>MENU.PROFILE.UNREGISTER</div></ion-item> 
      <ion-item button (click)="toggleMenu('corefacts')" *ngIf="showMenuEntry('MENU.COREFACTS.ABOUT')"><div translate>MENU.COREFACTS.ABOUT</div></ion-item>
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.COMPANY_INFO')" (click)="openLink('ABOUT')"><div translate>MENU.COREFACTS.COMPANY_INFO</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.SUPPORT')" (click)="openLink('CONTACT')"><div translate>MENU.COREFACTS.SUPPORT</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.HELP')" (click)="openLink('FAQ')"><div translate>MENU.COREFACTS.HELP</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.CONDITIONS')" (click)="openLink('CONDITIONS')"><div translate>MENU.COREFACTS.CONDITIONS</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.COPYRIGHT')" (click)="openLink('COPYRIGHT')"><div translate>MENU.COREFACTS.COPYRIGHT</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.DATA_PROTECTION')" (click)="openLink('PRIVACY')"><div translate>MENU.COREFACTS.DATA_PROTECTION</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.ACCESSIBILITY')" (click)="openGeneric('ACCESSIBILITY')"><div translate>MENU.COREFACTS.ACCESSIBILITY</div></ion-item> 
      <ion-item button class="second-level" *ngIf="menuOn('corefacts') && showMenuEntry('MENU.COREFACTS.REVIEW') && canLaunchReview()" (click)="doLaunchReview()"><div translate>MENU.COREFACTS.REVIEW</div></ion-item> 
  </ion-list>
  

  </ng-template>

  <ion-modal [keepContentsMounted]="true">
    <ng-template>
      <ion-datetime id="datetimeTimesDialogsFirst" #datetimeTimesDialogsFirst displayFormat="HH:mm" pickerFormat="HH:mm"
        hourValues="4,5,6,7,8,9,10,11,12" minuteValues="0,15,30,45"
        [(ngModel)]="settings.timesDialogsFirst"
        [doneText]="'SETTINGS.TIMES.DONE' | translate" [cancelText]="'SETTINGS.TIMES.CANCEL' | translate"
        [formatOptions]="{
          time: { hour: '2-digit', minute: '2-digit' },
          date: { day: '2-digit', month: 'long' },
        }"
        presentation="time">
        <ion-buttons slot="buttons">
          <ion-button (click)="setDialogsTimesAutomatic(true);datetimeTimesDialogsFirst.cancel(true)" translate>SETTINGS.TIMES.AUTOMATIC.BUTTON</ion-button>
          <ion-button (click)="datetimeTimesDialogsFirst.confirm(true)" translate>COMMON.OK</ion-button>
        </ion-buttons>
      </ion-datetime>
    </ng-template>
  </ion-modal>

  <ion-modal [keepContentsMounted]="true">
    <ng-template>
      <ion-datetime id="datetimeTimesDialogsSecond" #datetimeTimesDialogsSecond displayFormat="HH:mm" pickerFormat="HH:mm"
        hourValues="14,15,16,17,18,19,20" minuteValues="0,15,30,45"
        [(ngModel)]="settings.timesDialogsSecond"
        [doneText]="'SETTINGS.TIMES.DONE' | translate" [cancelText]="'SETTINGS.TIMES.CANCEL' | translate"
        [formatOptions]="{
          time: { hour: '2-digit', minute: '2-digit' },
          date: { day: '2-digit', month: 'long' },
        }"
        presentation="time">
        <ion-buttons slot="buttons">
          <ion-button (click)="setDialogsTimesAutomatic(true);datetimeTimesDialogsSecond.cancel(true)" translate>SETTINGS.TIMES.AUTOMATIC.BUTTON</ion-button>
          <ion-button (click)="datetimeTimesDialogsSecond.confirm(true)" translate>COMMON.OK</ion-button>
        </ion-buttons>
      </ion-datetime>
    </ng-template>
  </ion-modal>

</ion-content>
